module.exports = __webpack_public_path__ + "img/ic-arrow-right-white.e4991c23.svg";